import React from 'react';
import styled from 'styled-components';
import { assetPath } from '../../utils/web-helper';
import { fontQuicksand } from '../purchase/mixin';
import UnsupportedScreenBackImg from '~images/student/unsupported-screen-back.jpg';
import { UnsupportedLandscapeImg } from '../../constant-data/image-cdn-urls';
import { darkBlue } from '../../components/loggedout/shared-styles/Colors';
import { breakpoints } from '../../utils/responsive_utilities';
import Image from '../loggedout/common/Image';

export function UnsupportedLandscapeScreenShow () {
	return (
		<ParentBodyLandscape>
            <UnsupportedLandscapeScreenOverlay />
            <Wrapper>
                <Heading1>Please rotate your device</Heading1>
                <Heading2>The page opens in portrait mode</Heading2>
                <UnsupportedLandscapeImage><Image src={UnsupportedLandscapeImg} isCdnImage="true" alt="Unsupported landscape img"/></UnsupportedLandscapeImage>
            </Wrapper>
		</ParentBodyLandscape>
	)
}

export const ParentBodyLandscape = styled.div`
    background: url(${assetPath(UnsupportedScreenBackImg)}) no-repeat;
    background-size: cover;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
`;

export const UnsupportedLandscapeScreenOverlay = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.171);
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 90%;
    color: ${darkBlue};
`

export const Heading1 = styled.div`
    ${fontQuicksand(2.6, 3.6, 7)};
    padding-top: 2rem;
    @media screen and (min-width:${breakpoints.md + 1}px) {
        ${fontQuicksand(5, 3.6, 7)};
    }
`;

export const Heading2 = styled.div`
    ${fontQuicksand(1.6, 2)};
    padding: 1rem 0 2rem;
    @media screen and (min-width:${breakpoints.md + 1}px) {
        ${fontQuicksand(3, 2.8, 5)};
    }
`;

export const UnsupportedLandscapeImage = styled.div`
    height: 100%;
    img {
        height: 100%;
    }
`